import type { OrderFormLine } from './types';

export function canProceedOrderFormStep1(input: {
  selectedProducts: OrderFormLine[];
  showSaleProfitPlusFields: boolean;
  profitReferenceDataReady: boolean;
  profitStep1Ready: boolean;
}): boolean {
  if (input.selectedProducts.length === 0) return false;
  if (!input.showSaleProfitPlusFields) return true;
  return input.profitReferenceDataReady && input.profitStep1Ready;
}

export function canProceedOrderFormStep2(input: {
  selectedClient: unknown;
}): boolean {
  return input.selectedClient != null;
}
